import {GoogleOAuthProvider} from '@react-oauth/google'
import {
  DA1_UNIVERSAL_LOGIN_PATH,
  getPublicLoginPath,
  isDa1AuthUniversalLoginHost,
  isDa1LegacyMarketingLoginHost,
  isSelectiveAiDomains,
} from 'common/HelperFunctions'
import {shallowEqual, useSelector} from 'react-redux'
import {Navigate, Route, Routes, useLocation, useSearchParams} from 'react-router'
import {RootState} from 'setup'

import {NotFound} from '../errors/NotFound'
import {AuthLayout as OldAuthLayout} from './AuthLayout'
import {Auth} from './components/Auth'
import {ForgotPassword as OldForgotPassword} from './components/ForgotPassword'
import {GoogleAuthPage} from './components/GoogleAuthPage'
import {GoogleCallback} from './components/GoogleCallback'
import {GooglePasswordResetCallback} from './components/GooglePasswordResetCallback'
import {Login as OldLogin} from './components/Login'
import {ResetPassword} from './components/ResetPassword'
import {AuthLayout as NewAuthLayout} from './new/AuthLayout'
import {ForgotPassword as NewForgotPassword} from './new/components/ForgotPassword'
import {Login as NewLogin} from './new/components/Login'

const AuthPage = () => {
  const location = useLocation()
  const isLoggedIn = useSelector<RootState>(
    (state) => state.userReducer.isLoggedIn,
    shallowEqual
  ) as boolean

  const newScreens =
    (useSelector<RootState>(
      (state) => state.mainReducer.generalSettings.new_login_screen,
      shallowEqual
    ) as boolean) || false

  const [searchParams] = useSearchParams()
  const path = searchParams.get('path')

  if (isLoggedIn) {
    return <Navigate to={path || '/'} />
  }

  if (isDa1LegacyMarketingLoginHost() && location.pathname.endsWith('/login')) {
    return <Navigate to='/login' replace />
  }

  if (isDa1AuthUniversalLoginHost() && location.pathname.endsWith('/login')) {
    return <Navigate to={DA1_UNIVERSAL_LOGIN_PATH} replace />
  }

  let AuthLayout = OldAuthLayout
  let ForgotPassword = OldForgotPassword
  let Login = OldLogin
  if (newScreens) {
    AuthLayout = NewAuthLayout
    ForgotPassword = NewForgotPassword
    Login = NewLogin
  }

  const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID
  const showGoogleLogin = isSelectiveAiDomains() && googleClientId

  const routes = (
    <Routes>
      {/* Legacy path from Option A — redirect to top-level /login on auth host */}
      <Route path='universal-login' element={<Navigate to={getPublicLoginPath()} replace />} />
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password' element={<ResetPassword />} />
        <Route index element={<Auth />} />

        <Route path='*' element={<NotFound />} />
      </Route>
      {/* Google OAuth central auth page — serves popup on auth domain or localhost */}
      {showGoogleLogin && <Route path='google-login' element={<GoogleAuthPage />} />}
      {/* Google OAuth callback (receives token from auth domain) */}
      {showGoogleLogin && <Route path='google-callback' element={<GoogleCallback />} />}
      {showGoogleLogin && (
        <Route path='google-password-reset-callback' element={<GooglePasswordResetCallback />} />
      )}
    </Routes>
  )

  if (showGoogleLogin) {
    return <GoogleOAuthProvider clientId={googleClientId}>{routes}</GoogleOAuthProvider>
  }

  return routes
}

export {AuthPage}
